/* POVA experience — FEATURE STORY overlay.
   A fullscreen image/video slideshow (title + caption, progress dots, prev/next,
   a floating directional cursor, swipe, keyboard) opened from any element carrying
   data-xp-story="<key>". Slides come from the JSON the "POVA · Stories" section
   prints into #xp-stories-data, grouped by that key. One overlay (#xp-fstory) is
   reused for every story. Hidden until opened. */
(function () {
  var dataEl = document.getElementById('xp-stories-data');
  var overlay = document.getElementById('xp-fstory');
  if (!dataEl || !overlay) return;

  var all;
  try { all = JSON.parse(dataEl.textContent || '[]'); } catch (e) { all = []; }
  if (!all || !all.length) return;

  // Escape any stacking context inside #main so the overlay truly covers the page
  // (header/chrome included). Must be a direct child of <body>.
  if (overlay.parentNode !== document.body) document.body.appendChild(overlay);

  var stage = overlay.querySelector('[data-xp-stage]');
  var titleEl = overlay.querySelector('[data-xp-title]');
  var sTitleEl = overlay.querySelector('[data-xp-slide-title]');
  var sCapEl = overlay.querySelector('[data-xp-slide-caption]');
  var dotsEl = overlay.querySelector('[data-xp-dots]');
  var btnPrev = overlay.querySelector('[data-xp-prev]');
  var btnNext = overlay.querySelector('[data-xp-next]');
  var btnClose = overlay.querySelector('[data-xp-close]');

  // Floating directional cursor (follows the pointer over the media).
  var cursorEl = document.createElement('div');
  cursorEl.className = 'xpfs__cursor';
  cursorEl.setAttribute('aria-hidden', 'true');
  overlay.appendChild(cursorEl);

  var current = [], idx = 0, lastFocus = null;

  function buildMedia(slide) {
    if (slide.type === 'video' && slide.src) {
      var v = document.createElement('video');
      v.className = 'xpfs__media';
      v.src = slide.src; v.muted = true; v.loop = true; v.autoplay = true;
      v.playsInline = true; v.setAttribute('playsinline', ''); v.controls = false;
      if (slide.poster) v.poster = slide.poster;
      return v;
    }
    var img = document.createElement('img');
    img.className = 'xpfs__media';
    img.src = slide.src || ''; img.alt = slide.title || ''; img.decoding = 'async';
    return img;
  }

  function show(i) {
    if (!current.length) return;
    if (i < 0) i = 0;
    if (i > current.length - 1) i = current.length - 1;
    idx = i;
    var slide = current[idx];
    stage.innerHTML = '';
    stage.appendChild(buildMedia(slide));
    sTitleEl.textContent = slide.title || '';
    sTitleEl.style.display = slide.title ? '' : 'none';
    sCapEl.textContent = slide.caption || '';
    sCapEl.style.display = slide.caption ? '' : 'none';
    Array.prototype.forEach.call(dotsEl.children, function (d, n) { d.classList.toggle('is-on', n === idx); });
    btnPrev.disabled = idx === 0;
    btnNext.disabled = idx === current.length - 1;
  }

  function open(key, title) {
    current = all.filter(function (s) { return s.story === key; });
    if (!current.length) return;
    titleEl.textContent = title || key;
    dotsEl.innerHTML = '';
    current.forEach(function (_, n) {
      var b = document.createElement('button');
      b.type = 'button'; b.className = 'xpfs__dot'; b.setAttribute('aria-label', 'Slide ' + (n + 1));
      b.addEventListener('click', function () { show(n); });
      dotsEl.appendChild(b);
    });
    lastFocus = document.activeElement;
    document.body.classList.add('xpfs-open');
    overlay.hidden = false;
    overlay.setAttribute('aria-hidden', 'false');
    show(0);
    if (btnClose) btnClose.focus();
    document.addEventListener('keydown', onKey);
  }

  function close() {
    overlay.hidden = true;
    overlay.setAttribute('aria-hidden', 'true');
    overlay.classList.remove('is-cursor');
    document.body.classList.remove('xpfs-open');
    stage.innerHTML = '';
    document.removeEventListener('keydown', onKey);
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }

  // Focus trap (WCAG 2.1 §2.4.3 dialog pattern): while the overlay is open,
  // Tab from the last focusable element wraps to the first, and Shift+Tab
  // from the first wraps to the last, so keyboard focus can never leave
  // the dialog into the page behind it.
  function getFocusable() {
    var nodes = overlay.querySelectorAll('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])');
    return Array.prototype.filter.call(nodes, function (el) {
      return !el.disabled && el.offsetParent !== null;
    });
  }
  function trapTab(e) {
    if (e.key !== 'Tab') return;
    var focusable = getFocusable();
    if (!focusable.length) return;
    var first = focusable[0], last = focusable[focusable.length - 1];
    if (e.shiftKey) {
      if (document.activeElement === first || !overlay.contains(document.activeElement)) {
        e.preventDefault(); last.focus();
      }
    } else {
      if (document.activeElement === last || !overlay.contains(document.activeElement)) {
        e.preventDefault(); first.focus();
      }
    }
  }

  function onKey(e) {
    if (e.key === 'Escape') close();
    else if (e.key === 'ArrowRight') show(idx + 1);
    else if (e.key === 'ArrowLeft') show(idx - 1);
    else if (e.key === 'Tab') trapTab(e);
  }

  // Open triggers (delegated) — any element with data-xp-story.
  document.addEventListener('click', function (e) {
    var t = e.target.closest ? e.target.closest('[data-xp-story]') : null;
    if (!t) return;
    e.preventDefault();
    open(t.getAttribute('data-xp-story'), t.getAttribute('data-xp-story-title'));
  });
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter' && e.key !== ' ') return;
    var t = document.activeElement;
    if (t && t.matches && t.matches('[data-xp-story]')) {
      e.preventDefault();
      open(t.getAttribute('data-xp-story'), t.getAttribute('data-xp-story-title'));
    }
  });

  if (btnPrev) btnPrev.addEventListener('click', function () { show(idx - 1); });
  if (btnNext) btnNext.addEventListener('click', function () { show(idx + 1); });
  if (btnClose) btnClose.addEventListener('click', close);

  // Floating directional cursor + click-to-navigate (mouse only).
  stage.addEventListener('pointermove', function (e) {
    if (e.pointerType && e.pointerType !== 'mouse') return;
    var r = stage.getBoundingClientRect();
    var left = (e.clientX - r.left) < r.width / 2;
    cursorEl.textContent = left ? '←' : '→';
    cursorEl.style.transform = 'translate(' + e.clientX + 'px,' + e.clientY + 'px)';
    overlay.classList.add('is-cursor');
  });
  stage.addEventListener('pointerleave', function () { overlay.classList.remove('is-cursor'); });
  stage.addEventListener('click', function (e) {
    var r = stage.getBoundingClientRect();
    if ((e.clientX - r.left) < r.width / 2) show(idx - 1); else show(idx + 1);
  });

  // Touch swipe.
  var x0 = null;
  stage.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
  stage.addEventListener('touchend', function (e) {
    if (x0 === null) return;
    var dx = e.changedTouches[0].clientX - x0; x0 = null;
    if (Math.abs(dx) > 40) { if (dx < 0) show(idx + 1); else show(idx - 1); }
  }, { passive: true });
})();
